import axios from '../plugins/axios'
// const URL = 'http://localhost:5000';
//axios.defaults.headers.common['token'] = 'value' 
//call HID from localstorage

export default class hidServices {
  
  async getMaklumatIsiRumahByHID(HID){

    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/maklumatIsiRumah/getMaklumatIsiRumah?HID=`+HID, {
      })
      return res.data;
    } catch (error) {
      console.log(error)
      //return "FAILED";
    }

  }


  async simpanAhliIsiRUmah(data){
    try {

      const res = await axios.post(`${process.env.VUE_APP_API_URL}/maklumatIsiRumah/simpanAhliIsiRUmah`, {
      // PUSINGAN: data.PUSINGAN,
      // BULAN: data.BULAN,
      // TAHUN: data.TAHUN,
      // KAW: data.KAW,
      // NG: data.NG,
      // NEGERI: data.NEGERI,
      // BNO: data.BNO,
      
      
      // Alamat: data.Alamat,
      // Alamat1 : data.Alamat1,
      // Alamat2 : data.Alamat2,
      // Alamat3 : data.Alamat3,
      // Poskod : data.Poskod,
      // Notelefon : data.Notelefon,
      // Email : data.Email,
      // Sample : data.Sample,
      // P: data.P,
      // S : data.S,
      // DP : data.DP,
      // DB : data.DB,
      // BP : data.BP,
      // ST : data.ST,
      // NOTK : data.NOTK,
      // NOIR : data.NOIR,
      // R : data.R,
     
      HID: data.HID,
      BULAN: data.BULAN,
      TAHUN: data.TAHUN,
      KAW: data.KAW,
      NOAIR : data.NOAIR,
      Nama: data.Nama,
      PKIR: data.PKIR
    })
      
      //console.log(result);
      return res;

      
    } catch (error) {
      //console.log(error)
      console.log(error);  
  }
  }
  
   


}